export default __webpack_public_path__ + "static/media/trustwallet.4ca17b69.png";